import * as helper from './../../../Assets/Js/helper';
import {isInsideViewport} from "./insideViewport";

export function VideoHandler() {
	const video = document.querySelector('video');
	const scrollHandler = () => {
		if (isInsideViewport(video)) {
			video.play();
		} else {
			video.pause();
		}
	}

	if (video !== null) {
		helper.addEventListener(window, 'scroll', helper.debounce(scrollHandler, 150));
	}
}
